module.exports = __webpack_public_path__ + "static/media/yellowpath20.b2e511e8.png";